// @flow
import { makeStyles } from '@material-ui/core/styles'
export default makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    height: '100vh',
  },
  grid: {
    height: '100%',
  },
  quoteWrapper: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  quote: {
    backgroundColor: theme.palette.common.neutral,
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: 'url(/images/sign_up_1.jpg)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  },
  quoteInner: {
    textAlign: 'center',
    flexBasis: '600px',
  },
  quoteText: {
    color: theme.palette.common.white,
    fontWeight: 300,
  },
  name: {
    marginTop: theme.spacing(3),
    color: theme.palette.common.white,
  },
  bio: {
    color: theme.palette.common.white,
  },
  contentWrapper: {},
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  contentHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(5),
    paddingBototm: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  backButton: {},
  logoImage: {
    height: '200px',
    margin: 'auto',
    display: 'block',
  },
  contentBody: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  form: {
    paddingLeft: '100px',
    paddingRight: '100px',
    paddingBottom: '125px',
    flexBasis: '700px',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  title: {
    marginTop: `${theme.spacing(3)}px !important`,
  },
  subtitle: {
    color: theme.palette.text.secondary,
    marginTop: `${theme.spacing(0.5)}px !important`,
  },
  fields: {
    marginTop: `${theme.spacing(2)}px !important`,
  },
  textField: {
    '& + & ': {
      marginTop: `${theme.spacing(2)}px !important`,
    },
  },
  policy: {
    display: 'flex',
    alignItems: 'center',
  },
  policyCheckbox: {
    marginLeft: '-14px',
  },
  policyText: {
    display: 'inline',
    color: `${theme.palette.text.secondary} !important`,
  },
  policyUrl: {
    color: `${theme.palette.text.primary} !important`,
    '&:hover': {
      cursor: 'pointer',
      color: `${theme.palette.primary.main} !important`,
    },
  },
  signInButton: {
    marginTop: `${theme.spacing(2)}px !important`,
    width: '100%',
  },
  signUp: {
    marginTop: `${theme.spacing(2)}px !important`,
    color: `${theme.palette.text.secondary} !important`,
  },
  signUpUrl: {
    color: `${theme.palette.primary.main} !important`,
    fontWeight: 'bold',
    '&:hover': {
      color: `${theme.palette.primary.main} !important`,
    },
  },
  fieldError: {
    color: `${theme.palette.error.main} !important`,
    marginBottom: `${theme.spacing(2)}px !important`,
    marginTop: `${theme.spacing(2)}px !important`,
  },
  submitError: {
    color: `${theme.palette.error.main} !important`,
    alignText: 'center',
    marginBottom: `${theme.spacing(2)}px !important`,
    marginTop: `${theme.spacing(2)}px !important`,
  },
}))
